import ApiService from "../Services/ApiService";
import Teachr from "../Objects/models/Teachr";
import  Sponsorship  from "../Objects/models/Sponsorship";
import { ENV_DECLARONS, isBrandActive, getActiveBrand } from "../config/environment.config";

export interface ParamSponsorship {
  teachr: Teachr;
  page: number;
  limit: number;
  statut?: string;
  search?: string;
}

export default abstract class SponsorshipRepository {

  public static getSponsorshipByTeachr({ teachr, page, limit, statut, search }: ParamSponsorship) {
    const params = new URLSearchParams();
    params.set("page", page.toString());
    params.set("limit", limit.toString());
    params.set("statut", statut?.toString() ?? '');
    params.set("search", search?.toLowerCase().toString() ?? '');
    return ApiService.get(`/sponsorships/${teachr.id}?${params.toString()}`);
  }

  public static findOneSponsorship(sponsorship: Sponsorship) {
    return ApiService.get(`/sponsorships/one/${sponsorship}`);
  }

  public static retriveSponsorshipByCode(code: string) {
    return ApiService.get(`/sponsorships/find/code?code=${code}`);
  }

  public static addSponsorshipByTeachr(
    teachr: Teachr,
    sponsorship: Sponsorship
  ) {
    return ApiService.postInstance<Sponsorship>(
      `/sponsorships/${teachr.id}/mail${isBrandActive(ENV_DECLARONS) ? `?brand=${getActiveBrand()}` : ''}`,
      Sponsorship,
      sponsorship
    );
  }

  public static createSponsorship(sponsorship: Sponsorship, teachr: Teachr) {
    return ApiService.postInstance<Sponsorship>(
      `/sponsorships/${teachr.id}`,
      Sponsorship,
      sponsorship
    );
  }

  public static updateSponsorship(teachr: Teachr, sponsorship: Sponsorship) {
    return ApiService.putInstance<Sponsorship>(
      `/sponsorships/${teachr.id}/update`,
      Sponsorship,
      sponsorship
    );
  }

  public static deleteSponsorship(sponsorshipId: number) {
    return ApiService.deleteInstance(`/sponsorships/${sponsorshipId}`);
  }
}
